// Variables the SMS renderer can actually resolve.
//
// MUST stay in sync with the variable map in backend/sms-send-from-automation.
// Anything offered here but missing there sends to the customer as a literal
// "{{booking.foo}}": visible in the message, billed as part of a segment, and
// impossible to recall. Widening this list means widening that map first.
//
// The email builder deliberately has no equivalent restriction — it shows the
// whole smart-values catalog, because its renderer resolves the whole catalog.
export const SMS_VARIABLE_KEYS = [
  'customer.firstName',
  'customer.lastName',
  'customer.email',
  'customer.phone',
  'booking.id',
  'booking.date',
  'booking.startTime',
  'booking.endTime',
  'booking.groupSize',
  'booking.status',
  'game.name',
  'company.name',
  'company.phone',
  'companyGroup.name',
  'companyGroup.email',
  'companyGroup.phone',
  'companyGroup.city',
  'transaction.id',
];

// Preview-only stand-ins. The smart-values catalog carries its own
// example_value per entry, but the drawer needs samples for templates loaded
// from the database, before the panel has ever been opened.
export const SMS_SAMPLE_VALUES = {
  'customer.firstName': 'Jana',
  'customer.lastName': 'Schilbe',
  'customer.email': 'jana@example.com',
  'customer.phone': '(415) 555-0123',
  'booking.id': '4821',
  'booking.date': 'Fri, Sep 12',
  'booking.startTime': '7:00 PM',
  'booking.endTime': '8:00 PM',
  'booking.groupSize': '6',
  'booking.status': 'Confirmed',
  'game.name': 'The Vault',
  'company.name': 'Off the Couch',
  'company.phone': '(415) 555-0100',
  'companyGroup.name': 'Off the Couch',
  'companyGroup.email': 'contact@offthecouchgames.com',
  'companyGroup.phone': '(415) 555-0100',
  'companyGroup.city': 'Fremont',
  'transaction.id': '90210',
};
